export function isNullOrUndefined(arg: any): arg is null | undefined {
  return typeof arg === 'undefined' || arg === null
}

export function isFileArray(arg: any): arg is File[] {
  return Array.isArray(arg) && arg.every(item => item instanceof File)
}
